dmx.Formatters('null', {

    // default(value):Any
    default: function(o, value) {
        return value;
    }

});
